var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSabbDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 28,
    viewBox: "0 0 52 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2276 2.51128V25.142L0.908398 13.8236L12.2276 2.51128Z",
    stroke: "#DB0011"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8653 27.0222L26.1795 15.7071L37.4931 27.0222H14.8653Z",
    stroke: "#DB0011"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1796 11.8118L14.8655 0.5H37.4936L26.1796 11.8118Z",
    stroke: "#DB0011"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7012 25.1417V2.51162L51.0154 13.8236L39.7012 25.1417Z",
    stroke: "#DB0011"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabbDefaultIcon);
export default __webpack_public_path__ + "static/media/sabb-default-icon.ad94a0c89f7d0768c1815c2a0c84d73a.svg";
export { ForwardRef as ReactComponent };